import React, { useState, useEffect } from 'react';

import { useParams, useHistory } from 'react-router-dom';
import {
  encodeDna,
  StatueColor,
  StatueType,
  BgColor,
  BgObject,
  StatueData,
  decodeDna,
} from 'statue-helpers';
import { Loading } from '@zeit-ui/react';

import './index.css';
import { getTokenURI } from '../../utils/contractCalls';
import { useDrizzleHelper } from '../../utils/drizzleHelpers';
import { getMetadata } from '../../utils/api';

export default function StatueDetail() {
  const { drizzle, drizzleInitialized } = useDrizzleHelper();
  const [isLoading, setIsLoading] = useState(true);
  const [statueData, setStatueData] = useState<StatueData>({} as StatueData);
  const { statueId }: { [statueId: string]: string } = useParams();
  const history = useHistory();

  useEffect(() => {
    if (!drizzleInitialized) {
      return;
    }

    getTokenURI(drizzle, statueId)
      .then((tokenUri) => getMetadata(tokenUri))
      .then((metadata) => {
        setStatueData({
          id: statueId,
          statue: decodeDna(metadata.name),
          videoUrl: metadata.animation_url,
        });
        setIsLoading(false);
      })
      .catch((err) => {
        console.log(`Problem fetching data: ${err}`);
        history.replace('/not-found');
      });
  }, [drizzle, statueId, history, drizzleInitialized]);

  const { statue, videoUrl } = statueData;

  return (
    <div className="StatueDetail">
      {isLoading ? (
        <Loading>Loading</Loading>
      ) : (
        <div className="content">
          <div className="title">
            <h2 className="header">RENDER</h2>
            <p>{encodeDna(statue)}</p>
          </div>

          <video autoPlay muted loop>
            <source src={videoUrl} type="video/mp4" />
            Your browser does not support HTML5 video.
          </video>

          <h3>ATTRIBUTES</h3>
          <div className="attributes">
            <div className="statue">
              <ul>
                <li>
                  TOP: {StatueColor[statue.topColor]}{' '}
                  {StatueType[statue.topStatue]}
                </li>
                <li>
                  MIDDLE: {StatueColor[statue.middleColor]}{' '}
                  {StatueType[statue.middleStatue]}
                </li>
                <li>
                  BOTTOM: {StatueColor[statue.bottomColor]}{' '}
                  {StatueType[statue.bottomStatue]}
                </li>
              </ul>
            </div>
            <div className="objects">
              <ul>
                <li>SCENE: {BgColor[statue.bgColor]}</li>
                <li>BG OBJECT 1: {BgObject[statue.bgObjectOne]}</li>
                <li>BG OBJECT 2: {BgObject[statue.bgObjectTwo]}</li>
              </ul>
            </div>
          </div>

          {/* <h3>OWNER</h3>
          <h3>PREVIOUS OWNERS</h3> */}
        </div>
      )}
    </div>
  );
}
